import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export function TaxonomyManager({ kind, icon, title, items, reload }) {
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setBusy(true);
    try {
      await api.post("/taxonomies", { kind, name: name.trim() });
      setName("");
      reload();
      toast.success(`Added ${kind}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed");
    } finally {
      setBusy(false);
    }
  };

  const del = async (id) => {
    if (!window.confirm(`Delete this ${kind}?`)) return;
    await api.delete(`/taxonomies/${id}`);
    reload();
  };

  return (
    <div className="card-surface admin-card p-5" data-testid={`taxonomy-${kind}`}>
      <div className="flex items-center gap-2 mb-4">
        <span style={{ color: "var(--accent)" }}>{icon}</span>
        <h2 className="text-lg font-bold">{title}</h2>
        <span className="text-xs text-slate-500">({items.length})</span>
      </div>
      <form onSubmit={add} className="flex gap-2 mb-3">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={`Add a new ${kind}…`}
          data-testid={`tax-input-${kind}`}
          className="input flex-1"
        />
        <button
          disabled={busy}
          data-testid={`tax-add-${kind}`}
          className="px-3 py-2 rounded-lg bg-[color:var(--accent)] text-black text-sm font-bold disabled:opacity-60"
        >
          <Plus size={14} />
        </button>
      </form>
      {items.length === 0 && <div className="text-xs text-slate-500">None yet. Add the first one above.</div>}
      <ul className="space-y-1">
        {items.map((it) => (
          <li key={it.id} className="flex items-center justify-between rounded px-3 py-1.5 hover:bg-[#0b0d12] transition-colors" data-testid={`tax-item-${kind}-${it.id}`}>
            <span className="text-sm">{it.name}</span>
            <button
              onClick={() => del(it.id)}
              data-testid={`tax-del-${kind}-${it.id}`}
              className="text-slate-500 hover:text-[#ff3b5c] transition-colors"
            >
              <Trash2 size={14} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default TaxonomyManager;
